import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsSellerMethods.sss';

interface Props {
  className?: string,
}

export const ProductDetailsSellerMethodsSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <ul className={classNames(s.row, className)}>
      {Array(3).fill(null).map((_, i) => (
        <li
          key={i}
          className={s.column}
        >
          <Skeleton
            width='50%'
            height='14px'
          />

          <ul className={s.list}>
            {Array(3).fill(null).map((__, j) => {
              return (
                <li
                  key={j}
                  className={s.item}
                >
                  <div className={s.icon}>
                    <Skeleton
                      type='circle'  
                      width='24px'
                      height='24px'
                    />
                  </div>

                  <Skeleton
                    width='100%'
                    height='12px'
                  />
                </li>
              );
            })}
          </ul>
        </li>
      ))}
    </ul>
  );
};
